import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

// Styled Components
const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f4f4f4;
`;

const LoginBox = styled.div`
  background: white;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 300px;
`;

const Title = styled.h2`
  margin-bottom: 20px;
  color: #333;
  text-align: center;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box;
  &:focus {
    border-color: #5a8b37;
    outline: none;
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 10px;
  background-color: #5a8b37;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  margin-top: 10px;
  &:hover {
    background-color: #6fa94c;
  }
`;

// const LoginPage = () => {
//   const handleLogin = (e) => {
//     e.preventDefault();
//     // Add your login logic here
//   };

//   return (
//     <Container>
//       <LoginBox>
//         <Title>Login</Title>
//         <form onSubmit={handleLogin}>
//           <Input type="text" placeholder="Username" required />
//           <Input type="password" placeholder="Password" required />
//           <Button type="submit">Login</Button>
//         </form>
//       </LoginBox>
//     </Container>
//   );
// };

// export default LoginPage;
const LoginPage = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const navigate = useNavigate();
  
    const handleLogin = (e) => {
      e.preventDefault();
      console.log("Username:", username);
      console.log("Password:", password);
      // Add your login logic here
        
  // Check if username and password match the criteria
  if (username === 'admin' && password === '@ghaPro123') {
    // If matched, set isAuthenticated to true in localStorage
    localStorage.setItem('isAuthenticated', 'true');
    console.log("Logged in successfully!");
    navigate('/adminPanel'); // Redirect to admin panel

    // Add any additional logic for redirection or state management
  } else {
    // If not matched, show an alert
    alert('Wrong username and password');
  }
    };
  
    return (
      <Container>
        <LoginBox>
          <Title>Login</Title>
          <form onSubmit={handleLogin}>
            <Input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
            <Input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <Button type="submit">Login</Button>
          </form>
        </LoginBox>
      </Container>
    );
  };
  
  export default LoginPage;